import { Box, Grid2 as Grid, Typography } from '@mui/material';
import { UserCounters, UserDetail } from '../types';
import React, { useState } from 'react';
import achievements from '../assets/achievements.png';
import books from '../assets/books.png';
import clans from '../assets/clans.png';
import collections from '../assets/collections.png';
import contests from '../assets/contests1.png';
import friends from '../assets/friendsIcon.png';
import gifts from '../assets/gift.png';
import quests from '../assets/Quest.png';
import { useNavigate } from 'react-router-dom';
import works from '../assets/works.png';

interface UserScoresProps {
  userCounters: UserCounters | null;
  isMobile: boolean | null;
  handle: string | undefined;
  userId: string | undefined;
  userDetail: UserDetail | null;
}

const UserScores: React.FC<UserScoresProps> = ({ userCounters, isMobile, handle, userId, userDetail }) => {
  const navigate = useNavigate();
  const [showFriendsAlert, setShowFriendsAlert] = useState(false);
  const [showGiftsAlert, setShowGiftsAlert] = useState(false);
  const handleActions = (label: string) => {
    if (label === 'Friends') {
      setShowFriendsAlert(true);
      setTimeout(() => setShowFriendsAlert(false), 30000);
      return;
    }
    if (label === 'Gifts') {
      setShowGiftsAlert(true);
      setTimeout(() => setShowGiftsAlert(false), 30000);
      return;
    }
    navigate(`/user/${handle}/${label.toLowerCase()}`, {
      state: { userDetail, userId }
    });
  };
  return (
    <Box
      my={{ sm: 1, md: 2 }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
      <Grid
        container
        spacing={{ xs: 2, sm: 4, md: 4 }}
        my={{ xs: 2, sm: 4, md: 6 }}
        sx={{
          cursor: 'pointer',
          objectFit: 'contain',
          placeItems: 'center',
          justifyContent: 'center',
          alignItems: 'flex-start'
        }}>
        {[
          { label: 'Works', value: userCounters?.posts, icon: works },
          { label: 'Books', value: userCounters?.books, icon: books },

          { label: 'Friends', value: 0, icon: friends },
          {
            label: 'Contests',
            value: userCounters && userCounters?.c_win + userCounters?.c_part,
            icon: contests
          },
          { label: 'Clans', value: userCounters?.contests, icon: clans },

          {
            label: 'Achievements',
            value: userCounters?.achievements,
            icon: achievements
          },
          { label: 'Gifts', value: userCounters?.contests, icon: gifts },
          {
            label: 'Collections',
            value: userCounters?.collections,
            icon: collections
          },
          { label: 'Quests', value: userCounters && userCounters?.mc_win + userCounters?.mc_part, icon: quests }
        ].map(({ label, value, icon }, idx) => (
          <Grid
            key={idx}
            size={{ xs: 3, sm: 3, md: 2, lg: 1 }}
            sx={{
              textAlign: 'center',
              cursor: 'pointer',
              objectFit: 'contain',
              placeItems: 'center',
              margin: { xs: '5px 3px', sm: '5px 10px', md: '5px 10px' }
            }}
            onClick={() => handleActions(label)}
            display="flex"
            flexDirection="column"
            alignContent="center"
            justifyContent="center">
            <div
              style={{
                position: 'relative',
                width: '100%',
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'center'
              }}>
              {/* {label === 'Friends' && showFriendsAlert && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: '-30px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: 'transparent',
                    color: 'white',
                    margin: '3px',
                    padding: '4px 12px',
                    border: '1px white',
                    borderRadius: '999px',
                    fontSize: { xs: '8px', md: '12px' },
                    fontFamily: 'Baloo2',
                    fontWeight: '500',
                    whiteSpace: 'nowrap',
                    zIndex: 10,
                    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.2)'
                  }}>
                  Coming Soon
                </Box>
              )} */}
              {label === 'Gifts' && showGiftsAlert && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: '-30px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: 'transparent',
                    color: 'white',
                    margin: '3px',
                    padding: '4px 12px',
                    border: '1px white',
                    borderRadius: '999px',
                    fontSize: { xs: '8px', md: '12px' },
                    fontFamily: 'Baloo2',
                    fontWeight: '500',
                    whiteSpace: 'nowrap',
                    zIndex: 10,
                    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.2)'
                  }}>
                  Coming Soon
                </Box>
              )}
              <img src={icon} alt={label} width={isMobile ? '75%' : '95px'} height={isMobile ? '75%' : '95px'} />
            </div>
            <Typography fontSize={{ xs: '13px', md: '18px' }} fontFamily="Baloo2" fontWeight={800}>
              {label}
            </Typography>
            <Typography
              fontSize={{ xs: '13px', md: '18px' }}
              fontFamily="Baloo2"
              fontWeight={500}
              sx={{
                background: isMobile
                  ? 'linear-gradient(89.82deg, #C80864 0.16%, #FA4E76 0.17%, #0848EC 99.85%)'
                  : 'rgba(31, 29, 58, 0.6)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                color: 'White'
              }}>
              {value}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default UserScores;
